import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { ProofingConfigModel } from './proofingconfig-model';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { catchError, retry } from 'rxjs/operators';
import { ApiMethod } from '../../apimethods/api-method';
import { config } from 'process';
declare var $;

@Component({
  selector: 'app-proofing-config',
  templateUrl: './proofing-config.component.html',
  styleUrls: ['./proofing-config.component.css']
})
export class ProofingConfigComponent implements OnInit {

  modelItem = new ProofingConfigModel();

  @ViewChild('textarea') textarea: ElementRef;
  @ViewChild('dataTable', { static: false }) table;
  dataTable: any;
  title: string;
  dataSet: any;
  public typeList: any;
  public stageList: any;

  showModal: boolean;
  count: string;
  popUpButtonText: string;
  artstageList: any;
  publisherList: any;
  journalList: any;
  articleTypeList: any;
  CountryList: any;
  Language: any;
  ProofingType: any;
  configJournalId: any;
  configStageSelection: any;
  configProofingType: any;
  populatedList: string[] = [];
  DynamicTagList: any;
  mailbody: any;
  Reminderdata: any;
  configlist: any;

  ngOnInit() {
    ApiMethod.getBaseUrl();
    this.UpdatePanelHeight();
    $('#Txt_MailBody').jqte();
    $('#Txt_ProofRemindMailBody').jqte();
    $('#Txt_ConfirmationMailBody').jqte();

  }

  ngAfterViewChecked(): void {
    if ($('.jqte').length == 0) {
      $('#Txt_MailBody').jqte();
      $('#Txt_ProofRemindMailBody').jqte();
      $('#Txt_ConfirmationMailBody').jqte();
    }
    this.UpdatePanelHeight();
  }
  UpdatePanelHeight() {
    /*$('#myModalConfig .modal-body').css('height', (GlobalConstants.size.height));*/
    $('.tblRightsList').css('height', GlobalConstants.size.height - 100);
    $('#divProofSystemData').css('height', GlobalConstants.size.height - 100);
    $('#divDynamicTagList').css('height', (GlobalConstants.size.height) - 160);
    $('#divDynamicTagListRem').css('height', (GlobalConstants.size.height) - 160);
    $('#divProofing,#divReminder').css('height', (GlobalConstants.size.height) - 160);

    $('#divPreviewMain').css('height', (GlobalConstants.size.height) - 220);
    $('#txtSignature').css('height', (GlobalConstants.size.height) - 570);

  }

  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <ProofingConfigModel>data["ProofingConfigPage"];

        localStorage.aEID = 0;
        localStorage.StageNo = "";
        localStorage.ReminderNo = "";
        localStorage.configclone = 0;
        this.count = "0";


        $("#proofingTable").show();
        $("#proofingForm").hide();

        $("#ddlAppylist").select2({
          placeholder: "Select Publisher", dropdownParent: "#proofingForm"
        });


        $("#ddljournalList").select2({
          placeholder: "Select Journal", dropdownParent: "#proofingForm"
        });
        $('#ddljournalList').val([]).trigger('change');

        $("#ddlarticleList").select2({
          placeholder: "Select Article", dropdownParent: "#proofingForm"
        });
        $('#ddlarticleList').val([]).trigger('change');

        $("#ddlartstageList").select2({
          placeholder: "Select Stage", dropdownParent: "#proofingForm"
        });
        $('#ddlartstageList').val([]).trigger('change');

        $("#ddlLanguageList").select2({
          placeholder: "Select Language", dropdownParent: "#proofingForm"
        });
        $('#ddlLanguageList').val([]).trigger('change');

        $("#ddlCountryList").select2({
          placeholder: "Select Country", dropdownParent: "#proofingForm"
        });
        $('#ddlCountryList').val([]).trigger('change');

        $("#ddlProofingType").select2({
          placeholder: "Select ProofingType", dropdownParent: "#proofingForm"
        });
        $('#ddlProofingType').val('Select').trigger('change');

        $("#ddlProofingTypeFilter").select2({
          placeholder: "Select ProofingType", dropdownParent: "#Filters"
        });
        $('#ddlProofingTypeFilter').val('All').trigger('change');

        $("#ddljournals").select2({
          placeholder: "Select journals", dropdownParent: "#Filters"
        });
        $('#ddljournals').val([]).trigger('change');

        $("#ddlstagelistid").select2({
          placeholder: "Select stages", dropdownParent: "#Filters"
        });
        $('#ddlstagelistid').val([]).trigger('change');

        $("#ddlReminderCount").select2({
          placeholder: "Select ReminderCount", dropdownParent: "#divReminderMail"
        });
        $('#ddlReminderCount').val([]).trigger('change');

        this.GetProofingList();
        this.GetTypeList();
        this.GetApplyToList();
        this.GetProofingStageList();
        this.GetCountryList();
        this.GetLanguageList();
        this.GroupByProofingType();
        this.GetDynamicTagList();

        error => {
          ngswal("Warning !", error.message, "warning");
        }
      });

  }

  //Get All Countries list
  GetDynamicTagList(): void {
    ApiMethod.getMethod(this.modelItem.GetDynamicTagListAPI).subscribe(
      result => {
        this.DynamicTagList = result.aDynamicTagList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  //Get All Countries list
  GetCountryList(): void {
    ApiMethod.getMethod(this.modelItem.ProofingCountryListAPI).subscribe(
      result => {
        this.CountryList = result.aCountryList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  //Get All Languages list
  GetLanguageList(): void {
    ApiMethod.getMethod(this.modelItem.ProofingLanguageListAPI).subscribe(
      result => {
        this.Language = result.aLanguageList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  //Get All Countries list
  GroupByProofingType(): void {
    ApiMethod.getMethod(this.modelItem.GetProofingType).subscribe(
      result => {
        this.ProofingType = result.aProofingType;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  //Get Type
  GetTypeList(): void {
    ApiMethod.getMethod(this.modelItem.ConfigTypeListAPI).subscribe(
      result => {
        this.typeList = result.aTypeList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get ApplyTo List for dropdown
  GetApplyToList(): void {
    let npublisherId = localStorage.aPubID;
    ApiMethod.getMethod(this.modelItem.ProofingApplyToListAPI + npublisherId).subscribe(
      result => {
        this.publisherList = result.aPublisherList;
        this.journalList = result.aJournalList;
        this.articleTypeList = result.aArticleTypeList;
        this.artstageList = result.aArticleStageList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get Stage List
  GetProofingStageList(): void {
    ApiMethod.getMethod(this.modelItem.ProofingStageListAPI).subscribe(
      result => {
        this.stageList = result.aStageList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  /*  EmailID validation*/
  emailidOnly(event): boolean {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(event.currentTarget.value)) {
      //event.currentTarget.value = '';
      return ngswal("Warning !", "Invalid Email ID!", "warning");
    }
    return true;
  }
  //Email validation
  EmailValidation(event) {
    let Worngmailcount = 0;
    let str = event.currentTarget.value;
    let arr = str.split(/[;,]/);
    const regex = /^\{.*\}$/;
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    let validEmails = [];
    for (let i = 0; i < arr.length; i++) {
      let email = arr[i].trim();
      const isMatch = regex.test(email);
      if (isMatch) {
        validEmails.push(email);
        continue;
      } else {
        if (!filter.test(email)) {
          Worngmailcount++;
          continue;
        } else {
          validEmails.push(email);
        }
      }
    }
    event.currentTarget.value = validEmails.join(";");
    if (Worngmailcount > 0) {
      ngswal("Warning !", "Please Check Email ID!", "warning");
    }
  }

  //Multiple Email Id validation
  MultipleEmail(event) {
    let Worngmailcount = 0;
    let str = event.currentTarget.value;
    let arr = str.split(/[;,]/);
    let filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    let validEmails = [];
    for (let i = 0; i < arr.length; i++) {
      let email = arr[i].trim();
      if (!filter.test(email)) {
        Worngmailcount++;
        continue;
      }
      else {
        validEmails.push(email);
      }
    }
    event.currentTarget.value = validEmails.join(";");
    if (Worngmailcount > 0) {
      ngswal("Warning !", "Please Check Email ID!", "warning");
    }
  }

  resetFilter() {
    $('#ddlProofingType').val('Select').change();
    $('#ddljournals').val(0).change();
    $('#ddlstagelistid').val(0).change();
    this.GetProofingList();
  }

  //Load Data List
  GetProofingList(): void {
    $("#LoadingImage").show();
    var dataParam = {
      CreatedBy: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      ProofingType: $('#ddlProofingTypeFilter').val(),
      JournalList: $('#ddljournals').val().toString(),
      StageList: $('#ddlstagelistid').val().toString()
    }
    ApiMethod.postMethod(this.modelItem.ProofingListAPI, dataParam).subscribe(
      result => {
        if (result.aitemList === undefined) {
          ngswal("Failed !", "Your request could not be processed at this time. please try again later or check with admin team...", "warning");
        }
        else {
          this.dataSet = JSON.stringify(result.aitemList); // Data List
          this.dataSet = JSON.parse(this.dataSet);
          this.dataTable = $(this.table.nativeElement);

          //Dynamic datable
          let acolList = result.acolListL;
          let dataItem = new DataParam();
          dataItem.acolList = acolList;
          dataItem.aNewButtonName = 'btn_AddNew';
          dataItem.dataTable = this.dataTable;
          dataItem.dataset = this.dataSet;
          dataItem.dtheight = (GlobalConstants.size.height - 240);
          dataItem.modulename = 'ProofingConfigModule';

          this.dataTable = customfunctions.dynamicDataTable(dataItem);
        }
        //Dynamic datable
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }



  //Update ProofingConfig details method
  UpdateConfigDetails() {
    //Form validation added
    if ($('#txtName').val().trim() == '') {
      ngswal("Warning !", "Enter Proofing Workflow Name !", "warning");
    }
    if ($('#ddlProofingType').val() == 'Select') {
      ngswal("Warning !", "Enter Proofing Type !", "warning");
    }
    else if ($('#ddlartstageList').val().toString() == '') {
      ngswal("Warning !", "Please Select Stage!", "warning");
    }
    else {
      var getConfigList = [];
      getConfigList = GlobalConstants.GetTableRowToList('tblAddConfigList', null, true);

      if (getConfigList.length == 0) {
        ngswal("Warning !", "Add Proofingconfig details !", "warning");
        $("#LoadingImage").hide();
        return false;
      }
      for (var i = 0; i < getConfigList.length; i++) {
        getConfigList[i] = getConfigList[i].toString();
      }

      var getReminderList = [];
      getReminderList = GlobalConstants.GetTableRowToList('tblAddReminderList', null, true);
      for (var i = 0; i < getReminderList.length; i++) {
        getReminderList[i] = getReminderList[i].toString();
      }
      $("#LoadingImage").show();
      var dataItem = {
        ID: localStorage.aEID,
        PublisherId: localStorage.aPubID,
        Name: $('#txtName').val(),
        Instructions: $('#txtInstructions').val(),
        ProofingType: $('#ddlProofingType').val(),
        JournalList: $('#ddljournalList').val().toString(),
        ArticleTypeList: $('#ddlarticleList').val().toString(),
        StageList: $('#ddlartstageList').val().toString(),
        UpdatedBy: localStorage.aLoginID,
        ProofConfigList: getConfigList,
        ProofReminderList: getReminderList,
        IsIssue: $('#IsIssue').prop('checked'),
        LanguageIdList: $('#ddlLanguageList').val().toString(),
        CountryIdList: $('#ddlCountryList').val().toString(),
      };
      ApiMethod.postMethod(this.modelItem.UpdateAPI, dataItem).subscribe(
        resonse => {
          this.GetProofingList();
          $("#LoadingImage").hide();

          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: resonse.zresultL,
            showConfirmButton: true,
            timer: 1500
          });

          this.ClearAllData();
          this.BacktoConfigList();
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImage").hide();

        }
      );

    }

    return true;
  }


  //Show Edit or Add page depends on ID
  show(): void {
    this.ClearAllData();
    this.GetTypeList();
    $("#proofingTable").hide();
    $("#Filters").hide();
    if (localStorage.aEID != 0) {
      $("#LoadingImage").show();
      ApiMethod.getMethod(this.modelItem.ProofingByIdAPI + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImage").hide();
          let itemL = result.aitemList;
          let itemConfigL = result.aProofConfigList;
          let itemReminderL = result.aProofReminderList;
          this.configlist = itemConfigL;

          this.configJournalId = itemL.JournalList.toString();
          this.configStageSelection = itemL.StageList;
          this.configProofingType = itemL.ProofingType;

          // set dropdown values for edit page

          //Journallist ddl
          if (itemL.JournalList != null) {

            let data = itemL.JournalList.split(',');

            let selectedValues = new Array();
            try {
              for (var i = 0; i < data.length; i++) {
                selectedValues[i] = data[i];
              }
            } catch (e) {
            }
            $('#ddljournalList').val(selectedValues).change();

          }
          //article ddl
          if (itemL.ArticleTypeList != null) {

            let data = itemL.ArticleTypeList.split(',');

            let selectedValues = new Array();
            try {
              for (var i = 0; i < data.length; i++) {
                selectedValues[i] = data[i];
              }
            } catch (e) {
            }
            $('#ddlarticleList').val(selectedValues).change();

          }
          //artstage ddl
          if (itemL.StageList != null) {

            let data = itemL.StageList.split(',');

            let selectedValues = new Array();
            try {
              for (var i = 0; i < data.length; i++) {
                selectedValues[i] = data[i];
              }
            } catch (e) {
            }
            $('#ddlartstageList').val(selectedValues).change();

          }

          //LanguageList ddl
          if (itemL.LanguageIdList != null) {

            let data = itemL.LanguageIdList.split(',');

            let selectedValues = new Array();
            try {
              for (var i = 0; i < data.length; i++) {
                selectedValues[i] = data[i];
              }
            } catch (e) {
            }
            $('#ddlLanguageList').val(selectedValues).change();

          }

          //CountryIdList ddl
          if (itemL.CountryIdList != null) {

            let data = itemL.CountryIdList.split(',');

            let selectedValues = new Array();
            try {
              for (var i = 0; i < data.length; i++) {
                selectedValues[i] = data[i];
              }
            } catch (e) {
            }
            $('#ddlCountryList').val(selectedValues).change();

          }

          $('#txtName').val(itemL.Name);
          $('#txtInstructions').val(itemL.Instructions);
          $('#ddlProofingType').val(itemL.ProofingType).change();
          $('#IsIssue').prop("checked", (itemL.IsIssue));
          //Fill data for Config tab table


          $("#tblAddConfigList tbody").html("");
          let styleEdit = "style='color: #34c38f; font-size: 20px;cursor:Pointer;'";
          let styleclone = "style = 'color: #007bff; font-size: 20px; cursor: pointer;'";
          let styleDelete = styleEdit.replace("#34c38f;", "#f46a6a;");
          let styleMail = styleDelete.replace("#f46a6a;", "#135ebb;");
          if (itemConfigL.length != 0) {
            var nRowL = "";
            for (var i = 0; i < itemConfigL.length; i++) {
              nRowL += "<tr id='trsc_" + (i + 1).toString() + "'>";
              nRowL += "<td>" + (i + 1).toString() + "</td>";
              nRowL += "<td  id='stage_" + (i + 1).toString() + "' data-id='" + GlobalConstants.isNullCheck(itemConfigL[i].StageID) + "'>" + GlobalConstants.isNullCheck(itemConfigL[i].StageTitle) + "</span></td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(itemConfigL[i].Sequence) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(itemConfigL[i].TAT) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(itemConfigL[i].MailSubject) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].FromName) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].FromEmail) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].FromCopyrights) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].ToName) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].ToEmail) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].ToCopyrights) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].CC) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].SubmitCC) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].BCCEmail) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].Signature) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].IsOneMoreView) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].MailBody) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].Instructions) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].ConfirmationMailbody) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].AckMailSubject) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].CorrectionInputFile) + "</td>";
              nRowL += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemConfigL[i].CorrectionInputInstructions) + "</td>";
              nRowL += "<td style='text-align: center'>"
                + "<i class='bx bxs-edit-alt' title='Edit' " + styleEdit + " onclick=localStorage.EStageNo='" + (i + 1).toString() + "';$('#spAddConfig').trigger('click');></i>&nbsp;"
                + "<i class='bx bxs-trash' title='Delete' " + styleDelete + " onclick=localStorage.StageNo='" + (i + 1).toString() + "';$('#btnDeleteConfig').trigger('click');></i>&nbsp;"
                + "</td>";
              nRowL += "</tr>";
            }
            $("#tblAddConfigList tbody").append(nRowL);
          }

          //Fill data for Reminder tab table

          $("#tblAddReminderList tbody").html("");
          if (itemReminderL.length != 0) {

            var nRowR = "";

            for (var i = 0; i < itemReminderL.length; i++) {
              nRowR += "<tr id='trRc_" + (i + 1).toString() + "'>";
              nRowR += "<td>" + (i + 1).toString() + "</td>";
              nRowR += "<td>" + GlobalConstants.isNullCheck(itemReminderL[i].IntervalType) + "</td>";
              nRowR += "<td  id='reminder_" + (i + 1).toString() + "' data-id='" + GlobalConstants.isNullCheck(itemReminderL[i].StageID) + "'>" + GlobalConstants.isNullCheck(itemReminderL[i].StageTitle) + "</span></td>";
              nRowR += "<td>" + GlobalConstants.isNullCheck(itemReminderL[i].Sequence) + "</td>";
              nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemReminderL[i].IntervalDay) + "</td>";
              nRowR += "<td>" + GlobalConstants.isNullCheck(itemReminderL[i].Subject) + "</td>";
              nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemReminderL[i].StageName) + "</td>";
              nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemReminderL[i].FromEmail) + "</td>";
              nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemReminderL[i].ToEmail) + "</td>";
              nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemReminderL[i].CC) + "</td>";
              nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemReminderL[i].SubmitCC) + "</td>";
              nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemReminderL[i].BCCEmail) + "</td>";
              nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemReminderL[i].MailBody) + "</td>";
              nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemReminderL[i].Signature) + "</td>";
              nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemReminderL[i].Id) + "</td>";
              nRowR += "<td style='display:none'>" + GlobalConstants.isNullCheck(itemReminderL[i].ProofingSystemId) + "</td>";

              nRowR += "<td style='text-align: center'>"
                + "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;'  onclick=localStorage.EReminderNo='" + (i + 1).toString() + "';$('#spAddReminder').trigger('click');></i>&nbsp;"
                + "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.ReminderNo='" + (i + 1).toString() + "';$('#btnDeleteConfig').trigger('click');></i>"
                + "</td>";
              nRowR += "</tr>";
            }
            $("#tblAddReminderList tbody").append(nRowR);
          }

        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
      this.popUpButtonText = "Update";
    } else
      this.popUpButtonText = "Add";
    $("#proofingForm").show();
  }

  //stagebased data 
  PopulateStageBasedData() {
    let stageName = $('#ddlStageList option:selected').text();
    $('#txtToName').val('{' + stageName + ' Name}');
    $('#txtToEmail').val('{' + stageName + ' Email}');
    this.chekduplicatestage();
  }


  chekduplicatestage() {

    let stageName = $('#ddlStageList option:selected').text();
    var getConfigList = [];

    getConfigList = GlobalConstants.GetTableRowToList('tblAddConfigList', null, true);
    for (var i = 0; i < getConfigList.length; i++) {
      var configstage = getConfigList[i][1]; // Access the current item in the loop
      if (stageName == configstage) {
        ngswal("warning", stageName + " is repeated.", "warning");
        $('#ddlStageList').val(0).change();
        $('#txtToName').val('');
        $('#txtToEmail').val('');
      }
    }
  }


  ShowTransPopup() {
    let tabType = $('#ULTabul .active').attr('name');
    if (tabType == 'Config') {
      this.ShowConfig();
    }
    else {
      this.ShowReminder();
    }
  }

  /*---------------------------------------------------------------------------Config----------------------------------------------------------------------*/
  PreviewConfigData() {
    //let artStage = $('#ddlartstageList option:selected').text();
    //if (artStage.indexOf('Revises') > 0 && $('#TxtVolume').val() == '' && $('#TxtIssue').val() == '') {
    //  ngswal("Warning !", "Please Enter Volume and Issue !", "warning");
    //}
    //else if (artStage.indexOf('Revises') == -1 && $('#TxtArticleNo').val() == '') {
    //  ngswal("Warning !", "Please Enter ArticleNo !", "warning");
    //}
    //else {
    var dataItem = {
      ArticleNo: $('#TxtArticleNo').val(),
      Volume: $('#TxtVolume').val(),
      Issue: $('#TxtIssue').val(),
      JournalCode: $('#ddljournalList option:selected').text(),
      ProofingId: localStorage.aEID
    };
    ApiMethod.postMethod(this.modelItem.GetProofingConfigData, dataItem).subscribe(
      resonse => {
        let responseData = resonse; let proofigData = null;
        if (responseData.ProofingConfigData != null) {
          proofigData = resonse.ProofingConfigData;
        }
        if (responseData.WorkflowList != null) {
          proofigData = resonse.WorkflowList;
        }
        let htmlData = '<table with="100%" cellpadding="5" cellspacing="5">';

        $.each(proofigData, function (e, val) {
          htmlData += '<tr>';
          if ($('#ddlProofingType').val() != 'EPDS') {
            htmlData += '<td><strong>Stage : ' + GlobalConstants.isNullCheck(val.Stage) + '</strong></td>';
            htmlData += '</tr>';
          }
          htmlData += '<tr>';
          htmlData += '<td><strong>From Name : ' + GlobalConstants.isNullCheck(val.FromName) + '</strong></td>';
          htmlData += '</tr>';

          htmlData += '<tr>';
          htmlData += '<td><strong>From Email : ' + GlobalConstants.isNullCheck(val.FromEmail) + '</strong></td>';
          htmlData += '</tr>';

          htmlData += '<tr>';
          htmlData += '<td><strong>To Name : ' + GlobalConstants.isNullCheck(val.ToName) + '</strong></td>';
          htmlData += '</tr>';

          htmlData += '<tr>';
          htmlData += '<td><strong>To Email : ' + GlobalConstants.isNullCheck(val.ToEmail) + '</strong></td>';
          htmlData += '</tr>';

          htmlData += '<tr>';
          htmlData += '<td><strong>Cc Email : ' + GlobalConstants.isNullCheck(val.CC) + '</strong></td>';
          htmlData += '</tr>';

          htmlData += '<tr>';
          htmlData += '<td><strong>Bcc Email : ' + GlobalConstants.isNullCheck(val.Bcc) + '</strong></td>';
          htmlData += '</tr>';

          htmlData += '<tr>';
          htmlData += '<td><strong>Subject</strong> : ' + GlobalConstants.isNullCheck(val.MailSubject) + '</td>';
          htmlData += '</tr>';

          htmlData += '<tr>';
          htmlData += '<td><strong>MailBody</strong><br/>' + GlobalConstants.isNullCheck(val.MailBody) + '</td>';
          htmlData += '</tr>';

          if (GlobalConstants.isNullCheck(val.ConfirmationMailBody) != '') {

            htmlData += '<tr>';
            htmlData += '<td><strong>Confirmation Subject</strong><br/>' + GlobalConstants.isNullCheck(val.AckMailSubject) + '</td>';
            htmlData += '</tr>';

            htmlData += '<tr>';
            htmlData += '<td>';
            htmlData += '<hr/><strong>Confirmation MailBody</strong><br/>';
            htmlData += GlobalConstants.isNullCheck(val.ConfirmationMailBody);
            htmlData += '</td>';
            htmlData += '</tr>';
          }

          htmlData += '<tr>';
          htmlData += '<td><hr/></td>';
          htmlData += '</tr>';

        });

        htmlData += '</table>';

        $('#divPreviewData').html(htmlData);


      },
      error => {
        console.log('Mailbody fetch ' + error.message);
      }
    );
  }


  //ProofingConfig Modal display
  ShowConfig() {
    $('#divPreviewDetails input').val('');
    $('#ULTabulPopup a[href="#divProofing"]').trigger('click');
    $('#divPreviewData').html('');
    this.showModal = true;
    this.title = "Proofing Config Details";
    $('#Divmail .jqte_editor').css({ 'height': (GlobalConstants.size.height - 260), 'resize': 'none' });
    $('#DivmailConfirmation .jqte_editor').css({ 'height': (GlobalConstants.size.height - 260), 'resize': 'none' });
    if (localStorage.EStageNo != null) {
      this.Disablepopupfields();
      let trId = '#trsc_' + localStorage.EStageNo;

      var chkStageOption = this.stageList.filter(a => a.Stage == $(trId).find('td')[1].outerText);
      if (chkStageOption.length > 0) {
        $('#ddlStageList').val(chkStageOption[0].ID).change();
      }
      $("#txtSequence").val($(trId).find('td')[2].outerText);
      $("#txtTATConfig").val($(trId).find('td')[3].outerText);
      $("#txtMailSubject").val($(trId).find('td')[4].innerHTML);
      $("#txtFromName").val($(trId).find('td')[5].outerText);
      $("#txtFromEmail").val($(trId).find('td')[6].outerText);
      $("#txtCopyrights").val($(trId).find('td')[7].innerHTML);
      $("#txtToName").val($(trId).find('td')[8].outerText);
      $("#txtToEmail").val($(trId).find('td')[9].outerText);
      $("#txtCopyrights").val($(trId).find('td')[10].innerHTML);
      $("#txtCC").val($(trId).find('td')[11].outerText);
      $("#txtSubmitCC").val($(trId).find('td')[12].outerText);
      $("#txtBCCEmail").val($(trId).find('td')[13].outerText);
      $("#txtSignature").val($(trId).find('td')[14].innerHTML);
      if (($(trId).find('td')[15].outerText) == "true") {
        $('#IsoneMoreReview').prop("checked", true)
      } else {
        $('#IsoneMoreReview').prop("checked", false)
      }
      $('#Divmail .jqte_editor').html($(trId).find('td')[16].innerHTML);
      $("#txttoInstructions").val($(trId).find('td')[17].outerText);
      $('#DivmailConfirmation .jqte_editor').html($(trId).find('td')[18].innerHTML);

      if ($(trId).find('td')[18].outerText == "") {
        this.getConfirmation();
      }

      $("#txtAckMailSubject").val($(trId).find('td')[19].innerHTML);

      if (($(trId).find('td')[20].outerText) == "true") {
        $('#IsCorrectionInputFile').prop("checked", true)
      } else {
        $('#IsCorrectionInputFile').prop("checked", false)
      }

      if (($(trId).find('td')[21].outerText) == "true") {
        $('#IsCorrectionInputInstructions').prop("checked", true)
      } else {
        $('#IsCorrectionInputInstructions').prop("checked", false)
      }

      //Check MailBody data available in Config table

      if ($(trId).find('td')[16].outerText == '') {
        var dataItem = {
          JournalId: this.configJournalId.toString(),
          StageSelection: $('#ddlartstageList option:selected').text(),//this.configStageSelection,
          Stage: $(trId).find('td')[1].outerText,
          ProofingType: this.configProofingType
        };
        ApiMethod.postMethod(this.modelItem.GetMailBody, dataItem).subscribe(
          resonse => {

            this.mailbody = resonse.MailBody;

            if (resonse.Status == "Success") {
              $('#Divmail .jqte_editor').html(resonse.MailBody);
            }
            else {
              console.log(resonse.Message);
            }
            this.showModal = true;
          },
          error => {
            console.log('Mailbody fetch ' + error.message);
          }
        );
      }
      else {
        this.showModal = true;
      }
      $('#tabPreview').show();
    }
    else {
      this.ClearData();
      $('#tabPreview').hide();
    }
  }

  //Config COnfirmationMailBody 
  getConfirmation() {
    let trId = '#trsc_' + localStorage.EStageNo;
    var dataItem = {
      JournalId: this.configJournalId.toString(),
      StageSelection: $('#ddlartstageList option:selected').text(),
      Stage: $(trId).find('td')[1].outerText,
      ProofingType: this.configProofingType,
      PublisherId: localStorage.aPubID
    };
    ApiMethod.postMethod(this.modelItem.GetConfirmationMailBody, dataItem).subscribe(
      resonse => {

        this.mailbody = resonse.MailBody;

        if (resonse.Status == "Success") {
          $('#DivmailConfirmation .jqte_editor').html(resonse.ConfirmationMailBody);
        }
        else {
          console.log(resonse.Message);
        }
        this.showModal = true;
      },
      error => {
        console.log('Mailbody fetch ' + error.message);
      }
    );
  }


  //Add Data for config html table
  AddConfig() {

    let _mailBody = $("#Txt_MailBody").val().trim();
    let _confirMailBody = $("#Txt_ConfirmationMailBody").val().trim();

    if (_mailBody == '') {
      _mailBody = $('#Divmail .jqte_editor').html().trim();
    }
    if (_confirMailBody == '') {
      _confirMailBody = $('#DivmailConfirmation .jqte_editor').html().trim();
    }

    if ($('#ddlStageList').val().trim() == "0") {
      ngswal("Warning !", "Enter Stage Name!", "warning");
    }
    else if ($('#txtSequence').val().trim() == '') {
      ngswal("Warning !", "Enter Sequence!", "warning");
    }
    else if ($('#txtTATConfig').val().trim() == '') {
      ngswal("Warning !", "Enter TAT!", "warning");
    }
    else if ($('#txtMailSubject').val().trim() == '') {
      ngswal("Warning !", "Enter Mail Subject!", "warning");
    }
    else if ($('#txtToEmail').val().trim() == '') {
      ngswal("Warning !", "Enter To email!", "warning");
    }
    else if ($('#txtSignature').val().trim() == '') {
      ngswal("Warning !", "Enter Signature!", "warning");
    }
    else if (_mailBody == '') {
      ngswal("Warning !", "Enter Mail body!", "warning");
    }
    else if (_confirMailBody == '') {
      ngswal("Warning !", "Enter  Confirmation Mail Body!", "warning");
    }
    else {
      $("#LoadingImage").show();
      let zchkVal: boolean = true;
      // First check if a <tbody> tag exists, add one if not
      if ($("#tblAddConfigList tbody").length == 0) {
        $("#tblAddConfigList").append("<tbody></tbody>");
      }
      var zRowLength = $("#tblAddConfigList").find("tr").length;

      if (zRowLength >= 1) {
        $.each($("#tblAddConfigList tbody tr"), function (e) {
          if (localStorage.EStageNo != null) {
            zchkVal = false;
            $('#spUpdateConfig').trigger('click');
          }
          $("#LoadingImage").hide();
        });
      }

      if (zchkVal == true) {
        // Append product to the table
        $("#tblAddConfigList tbody").append(
          "<tr id='trsc_" + zRowLength.toString() + "'>" +
          "<td>" + zRowLength.toString() + "</td>" +
          "<td id=stage_" + zRowLength.toString() + ' onclick=localStorage.StageNo=' + zRowLength.toString() + ">" + $('#ddlStageList option:selected').text() + "</td>" +
          //"<td>" + $('#ddlStageList option:selected').text()+ "</td>" +
          "<td>" + $("#txtSequence").val() + "</td>" +
          "<td>" + $("#txtTATConfig").val() + "</td>" +
          "<td>" + $("#txtMailSubject").val() + "</td>" +
          "<td style='display:none'>" + $("#txtFromName").val() + "</td>" +
          "<td style='display:none'>" + $("#txtFromEmail").val() + "</td>" +
          "<td style='display:none'>" + $("#txtCopyrights").val() + "</td>" +
          "<td style='display:none'>" + $("#txtToName").val() + "</td>" +
          "<td style='display:none'>" + $("#txtToEmail").val() + "</td>" +
          "<td style='display:none'>" + $("#txtCopyrights").val() + "</td>" +
          "<td style='display:none'>" + $("#txtCC").val() + "</td>" +
          "<td style='display:none'>" + $("#txtSubmitCC").val() + "</td>" +
          "<td style='display:none'>" + $("#txtBCCEmail").val() + "</td>" +
          "<td style='display:none'>" + $("#txtSignature").val() + "</td>" +
          "<td style='display:none'>" + $("#IsoneMoreReview").val() + "</td>" +
          "<td style='display:none'>" + _mailBody + "</td>" +
          "<td style='display:none'>" + $("#txttoInstructions").val() + "</td>" +
          "<td style='display:none'>" + _confirMailBody + "</td>" +
          "<td style='display:none'>" + $("#txtAckMailSubject").val() + "</td>" +
          "<td style='display:none'>" + $("#IsCorrectionInputFile").val() + "</td>" +
          "<td style='display:none'>" + $("#IsCorrectionInputInstructions").val() + "</td>" +
          "<td style='text-align: center'>"
          + "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.EStageNo='" + zRowLength.toString() + "';$('#spAddConfig').trigger('click');></i>&nbsp;"
          + "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.StageNo='" + zRowLength.toString() + "';$('#btnDeleteConfig').trigger('click');></i>"
          + "</td>"
          + "</tr>"
        );

        $("#LoadingImage").hide();
        this.ClearData();
      }

    }
  }
  //Update config data
  UpdateConfigData(): void {

    let _mailBody = $("#Txt_MailBody").val().trim()
    let _confirMailBody = $("#Txt_ConfirmationMailBody").val().trim();

    if (_mailBody == '') {
      _mailBody = $('#Divmail .jqte_editor').html().trim();
    }
    if (_confirMailBody == '') {
      _confirMailBody = $('#DivmailConfirmation .jqte_editor').html().trim();
    }


    let trId = '#trsc_' + localStorage.EStageNo;
    $(trId).find('td')[1].outerHTML = "<td>" + $('#ddlStageList option:selected').text() + "</td>";
    $(trId).find('td')[2].outerHTML = "<td>" + $("#txtSequence").val() + "</td>";
    $(trId).find('td')[3].outerHTML = "<td>" + $("#txtTATConfig").val() + "</td>";
    $(trId).find('td')[4].outerHTML = "<td>" + $("#txtMailSubject").val() + "</td>";
    $(trId).find('td')[5].outerHTML = "<td style='display:none'>" + $("#txtFromName").val() + "</td>";
    $(trId).find('td')[6].outerHTML = "<td style='display:none'>" + $("#txtFromEmail").val() + "</td>";
    $(trId).find('td')[7].outerHTML = "<td style='display:none'>" + $("#txtCopyrights").val() + "</td>";
    $(trId).find('td')[8].outerHTML = "<td style='display:none'>" + $("#txtToName").val() + "</td>";
    $(trId).find('td')[9].outerHTML = "<td style='display:none'>" + $("#txtToEmail").val() + "</td>";
    $(trId).find('td')[10].outerHTML = "<td style='display:none'>" + $("#txtCopyrights").val() + "</td>";
    $(trId).find('td')[11].outerHTML = "<td style='display:none'>" + $("#txtCC").val() + "</td>";
    $(trId).find('td')[12].outerHTML = "<td style='display:none'>" + $("#txtSubmitCC").val() + "</td>";
    $(trId).find('td')[13].outerHTML = "<td style='display:none'>" + $("#txtBCCEmail").val() + "</td>";
    $(trId).find('td')[14].outerHTML = "<td style='display:none'>" + $("#txtSignature").val() + "</td>";
    $(trId).find('td')[15].outerHTML = "<td style='display:none'>" + $('#IsoneMoreReview').prop('checked') + "</td>";
    $(trId).find('td')[16].outerHTML = "<td style='display:none'>" + _mailBody + "</td>";
    $(trId).find('td')[17].outerHTML = "<td style='display:none'>" + $("#txttoInstructions").val() + "</td>";
    $(trId).find('td')[18].outerHTML = "<td style='display:none'>" + _confirMailBody + "</td>";
    $(trId).find('td')[19].outerHTML = "<td style='display:none'>" + $("#txtAckMailSubject").val() + "</td>";
    $(trId).find('td')[20].outerHTML = "<td style='display:none'>" + $('#IsCorrectionInputFile').prop('checked') + "</td>";
    $(trId).find('td')[21].outerHTML = "<td style='display:none'>" + $('#IsCorrectionInputInstructions').prop('checked') + "</td>";
    this.ClearData();
    $('#btnConfigHide').trigger('click');

  }

  //Delete Logic for reminder and config html table row
  DeleteConfig() {
    this.count = (parseInt(this.count) + 1).toString();
    $("#stage_" + localStorage.StageNo).closest("tr").remove();

    $("table#tblAddConfigList tbody").each(function () {
      $(this).children().each(function (index) {
        $(this).find('td').first().html((index + 1).toString());
      });
    });

    //Logic for Delete Reminder

    $("#reminder_" + localStorage.ReminderNo).closest("tr").remove();

    $("table#tblAddReminderList tbody").each(function () {
      $(this).children().each(function (index) {
        $(this).find('td').first().html((index + 1).toString());
      });
    });

  }
  /*---------------------------------------------------------------------------Remainder----------------------------------------------------------------------*/

  //ProofingReminder Modal display
  ShowReminder() {
    $('#divRemindPreviewtab input').val('');
    $('#ULTabulPopup a[href="#divReminder"]').trigger('click');
    $('#divPreviewData').html('');
    this.showModal = true;
    this.title = "Proofing Reminder Details";
    $('#proofremind').css('height', (GlobalConstants.size.height) - 100)
    $('#DivReminderMailData .jqte_editor').css({ 'height': (GlobalConstants.size.height - 300), 'resize': 'none' });
    if (localStorage.EReminderNo != null) {

      let trId = '#trRc_' + localStorage.EReminderNo;
      $("#ddlIntervalType").val($(trId).find('td')[1].outerText);
      var chkStageOption = this.stageList.filter(a => a.Stage == $(trId).find('td')[2].outerText);
      if (chkStageOption.length > 0) {
        $('#ddlRStageList').val(chkStageOption[0].ID).change();
      }
      $("#txtReminderCount").val($(trId).find('td')[3].outerText);
      $("#txtIntervalDay").val($(trId).find('td')[4].outerText);
      $("#txtRSubject").val($(trId).find('td')[5].outerText);
      $("#txtRStageName").val($(trId).find('td')[6].outerText);
      $("#txtRFromEmailId").val($(trId).find('td')[7].outerText);
      $("#txtRToEmailId").val($(trId).find('td')[8].outerText);
      $("#txtRCC").val($(trId).find('td')[9].outerText);
      $("#txtRBCCEmail").val($(trId).find('td')[10].outerText);
      $("#txtRSubmitCC").val($(trId).find('td')[11].outerText);

      $('#DivReminderMailData .jqte_editor').html($(trId).find('td')[12].innerHTML);
      this.Reminderdata = $(trId).find('td')[12].innerHTML;

      //Check MailBody data available in Reminder table
      if ($(trId).find('td')[12].outerText == '' || $(trId).find('td')[12].outerText == null) {
        this.getRemindermailbody();
      }
      else {
        this.showModal = true;
      }

      $("#txtRemindSignature").val($(trId).find('td')[13].outerText);


    }
    else {
      this.ClearData();
    }
  }

  //Get mailbody by default remainder count
  getRemindermailbody() {
    let trId = '#trRc_' + localStorage.EReminderNo;
    var dataItem = {
      ID: $(trId).find('td')[11].outerText,
      ProofingSystemID: $(trId).find('td')[12].outerText,
      JournalId: this.configJournalId.toString(),
      StageSelection: $('#ddlartstageList option:selected').text(),
      Stage: $(trId).find('td')[1].outerText,
      ProofingType: this.configProofingType,
      ReminderNo: $("#txtReminderCount").val()
    };
    ApiMethod.postMethod(this.modelItem.GetRemindMailBody, dataItem).subscribe(
      resonse => {
        this.mailbody = resonse.MailBody;
        if (resonse.Status == "Success") {
          $('#DivReminderMailData .jqte_editor').html(resonse.MailBody);
          this.Reminderdata = resonse.MailBody;
        }
        else {
          console.log(resonse.Message);
        }
        this.showModal = true;
      },
      error => {
        console.log('Mailbody fetch ' + error.message);
      }
    );
  }

  //Dynamic Tag 
  addDynamicTagListReminder() {
    const divElementsRemin = document.getElementById('DynamicTagListReminder');
    if (divElementsRemin.style.display === 'none') {
      divElementsRemin.style.display = 'block';
    } else {
      divElementsRemin.style.display = 'none';
    }
  }

  //Add Data for Reminder html table
  AddReminder() {

    let _reminderMailBody = $("#Txt_ProofRemindMailBody").val().trim()

    if (_reminderMailBody == '') {
      _reminderMailBody = $('#DivReminderMailData .jqte_editor').html().trim();
    }

    if ($('#ddlRStageList').val().trim() == "0") {
      ngswal("Warning !", "Select Stage!", "warning");
    }
    else if ($('#ddlIntervalType').val().trim() == '') {
      ngswal("Warning !", "Enter Interval Type!", "warning");
    }
    else if ($('#txtReminderCount').val().trim() == '') {
      ngswal("Warning !", "Enter Sequence !", "warning");
    }
    else if ($('#txtIntervalDay').val().trim() == '') {
      ngswal("Warning !", "Enter Interval Day!", "warning");
    }
    else if ($('#txtRSubject').val().trim() == '') {
      ngswal("Warning !", "Enter Subject!", "warning");
    }
    else if ($('#txtRToEmailId').val().trim() == '') {
      ngswal("Warning !", "Enter To EmailId!", "warning");
    }
    else if ($('#txtRCC').val().trim() == '') {
      ngswal("Warning !", "Enter CC!", "warning");
    }
    else if ($('#txtRemindSignature').val().trim() == '') {
      ngswal("Warning !", "Enter Signature !", "warning");
    }
    else if (_reminderMailBody == '') {
      ngswal("Warning !", "Enter Reminder Mail Body!", "warning");
    }
    else {
      $("#LoadingImage").show();
      let zchkVal: boolean = true;
      // First check if a <tbody> tag exists, add one if not
      if ($("#tblAddReminderList tbody").length == 0) {
        $("#tblAddReminderList").append("<tbody></tbody>");
      }
      var zRowTblLength = $("#tblAddReminderList").find("tr").length;
      if (zRowTblLength >= 1) {
        $.each($("#tblAddReminderList tbody tr"), function (e) {
          if (localStorage.EReminderNo != null) {
            zchkVal = false;
            $('#spUpdateReminder').trigger('click');
          }
          $("#LoadingImage").hide();
        });
      }

      // Append product to the table
      if (zchkVal == true) {
        $("#tblAddReminderList tbody").append(
          "<tr id='trRc_" + zRowTblLength.toString() + "'>" +
          "<td>" + zRowTblLength + "</td>" +
          "<td>" + $("#ddlIntervalType").val() + "</td>" +
          "<td id=reminder_" + zRowTblLength.toString() + ' onclick=localStorage.ReminderNo=' + zRowTblLength.toString() + ">" + $('#ddlRStageList option:selected').text() + "</td>" +
          "<td>" + $("#txtReminderCount").val() + "</td>" +
          "<td style='display:none'>" + $("#txtIntervalDay").val() + "</td>" +
          "<td>" + $("#txtRSubject").val() + "</td>" +
          "<td style='display:none'>" + $("#txtRStageName").val() + "</td>" +
          "<td style='display:none'>" + $("#txtRFromEmailId").val() + "</td>" +
          "<td style='display:none'>" + $("#txtRToEmailId").val() + "</td>" +
          "<td style='display:none'>" + $("#txtRCC").val() + "</td>" +
          "<td style='display:none'>" + $("#txtRSubmitCC").val() + "</td>" +
          "<td style='display:none'>" + $("#txtRBCCEmail").val() + "</td>" +
          "<td style='display:none'>" + _reminderMailBody + "</td>" +
          "<td style='display:none'>" + $("#txtRemindSignature").val() + "</td>"
          + "<td style='text-align: center'>"
          + "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.EReminderNo='" + zRowTblLength.toString() + "';$('#spAddReminder').trigger('click');></i>&nbsp;"
          + "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.ReminderNo='" + zRowTblLength.toString() + "';$('#btnDeleteConfig').trigger('click');></i>"
          + "</td>"
          + "</tr>"
        );
        $("#LoadingImage").hide();
        this.ClearData();
      }
    }
  }

  UpdateReminderData(): void {

    let _reminderMailBody = $("#Txt_ProofRemindMailBody").val().trim()

    if (_reminderMailBody == '') {
      _reminderMailBody = $('#DivReminderMailData .jqte_editor').html().trim();
    }

    let trId = '#trRc_' + localStorage.EReminderNo;

    $(trId).find('td')[1].outerHTML = "<td>" + $("#ddlIntervalType").val() + "</td>";
    $(trId).find('td')[2].outerHTML = "<td>" + $('#ddlRStageList option:selected').text() + "</td>";
    $(trId).find('td')[3].outerHTML = "<td>" + $("#txtReminderCount").val() + "</td>";
    $(trId).find('td')[4].outerHTML = "<td style='display:none'>" + $("#txtIntervalDay").val() + "</td>";
    $(trId).find('td')[5].outerHTML = "<td >" + $("#txtRSubject").val() + "</td>";
    $(trId).find('td')[6].outerHTML = "<td style='display:none'>" + $("#txtRStageName").val() + "</td>";
    $(trId).find('td')[7].outerHTML = "<td style='display:none'>" + $("#txtRFromEmailId").val() + "</td>";
    $(trId).find('td')[8].outerHTML = "<td style='display:none'>" + $("#txtRToEmailId").val() + "</td>";
    $(trId).find('td')[9].outerHTML = "<td style='display:none'>" + $("#txtRCC").val() + "</td>";
    $(trId).find('td')[10].outerHTML = "<td style='display:none'>" + $("#txtRBCCEmail").val() + "</td>";
    $(trId).find('td')[11].outerHTML = "<td style='display:none'>" + $("#txtRSubmitCC").val() + "</td>";

    if (this.Reminderdata != _reminderMailBody) {
      $(trId).find('td')[12].outerHTML = "<td style='display:none'>" + _reminderMailBody + "</td>";
      this.updatereminder();
    }
    $(trId).find('td')[13].outerHTML = "<td style='display:none'>" + $("#txtRemindSignature").val() + "</td>";

    this.ClearData();
    $('#btnReminderHide').trigger('click');
  }
  updatereminder() {

    let _reminderMailBody = $("#Txt_ProofRemindMailBody").val().trim()

    if (_reminderMailBody == '') {
      _reminderMailBody = $('#DivReminderMailData .jqte_editor').html().trim();
    }

    if (_reminderMailBody == '') {
      ngswal("Warning !", "Enter Reminder Mail Body!", "warning");
    }
    else {
      let trId = '#trRc_' + localStorage.EReminderNo;
      var ReminderNo = $("#ddlReminderCount").val();
      var dataItem = {
        ReminderId: $(trId).find('td')[13].outerText,
        ProofingSystemID: $(trId).find('td')[14].outerText,
        ReminderNo: ReminderNo,
        MailBody: _reminderMailBody
      };

      ApiMethod.postMethod(this.modelItem.GetReminderCountMailBody, dataItem).subscribe(
        resonse => {
          this.mailbody = resonse.MailBody;
          if (resonse.Status == "Success") {
            $('#DivReminderMailData .jqte_editor').html(resonse.MailBody);
          }
          else {
            console.log(resonse.Message);
          }
        },
        error => {
          console.log('Mailbody fetch ' + error.message);
        }
      );
    }
  }


  tabclick(): void {
    console.log('tabclick');
  }
  Disablepopupfields() {
    this.ClearData();
  }


  //Back to list page
  BacktoConfigList() {
    $('#ULTabul a[href="#ConfigTab"]').trigger('click');
    $("#proofingForm").hide();
    $("#proofingTable").show();
    $("#Filters").show();
    this.ClearAllData();
  }
  BacktoReminderList() {
    $("#proofingForm").hide();
    $("#proofingTable").show();
    this.ClearAllData();
  }

  //Bootstrap Modal Close event
  hide() {
    this.showModal = false;
    localStorage.removeItem('EStageNo');
    $("#DynamicTagList").hide();
    $('#myModalConfig').hide();
    $('#ULTabulPopup a[href="#divProofing"]').trigger('click');

  }
  Reminderhide() {
    this.showModal = false;
    localStorage.removeItem('EReminderNo');
    $("#DynamicTagListReminder").hide();
    $('#ULTabulPopup a[href="#divReminder"]').trigger('click');
  }
  //Delete 
  Delete() {
    ngswal({
      title: "Are you confirm to delete ProofConfing?",
      text: "ProofConfing deleted permenently !",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });
          $('#btnDeleteConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel! :)", "warning");
        }
      });
  }
  DeleteConfirm() {
    $('#LoadingImage').show();

    ApiMethod.postMethod(this.modelItem.DeleteProofingAPI + localStorage.aEID + '/' + localStorage.aLoginID, "").subscribe(
      result => {
        $("#LoadingImage").hide();
        this.hide();
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Deleted !",
          text: result,
          showConfirmButton: false,
          timer: 1500
        });
        this.GetProofingList();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }



  ClearData() {
    localStorage.removeItem('StageNo'); localStorage.removeItem('ReminderNo');

    //Config Data Clear
    $("#myModalConfig input[type='text']").val("");
    $("#myModalConfig input[type='number']").val("");
    $("#myModalConfig input[type='email']").val("");
    $("#myModalConfig input[type='checkbox']").prop("checked", false);
    $("#myModalConfig textarea").val("");
    $("#myModalConfig select").val(0).trigger('change');



    //Jqte editor
    $('#Divmail .jqte_editor').html('');
    $('#DivmailConfirmation .jqte_editor').html('');
    $('#DivReminderMailData .jqte_editor').html("");

    //Reminder Data Clear
    $("#myModalReminder input[type='text']").val("");
    $("#myModalReminder input[type='number']").val("");
    $("#myModalReminder input[type='email']").val("");
    $("#myModalReminder input[type='checkbox']").prop("checked", false);
    $("#myModalReminder textarea").val("");
    $("#myModalReminder select").val(0).trigger('change');


  }
  ClearAllData() {
    //For Proofing system
    $('#ddlTypeList').val(0).change();
    $('#ddlAppylist').val(0).change();
    $('#ddljournalList').val(0).change();
    $('#ddlarticleList').val(0).change();
    $('#ddlartstageList').val(0).change();
    $('#ddlLanguageList').val(0).change();
    $('#ddlCountryList').val(0).change();
    $('#ddlRStageList').val(0).change();

    $('#txtName').val('');
    $('#txtInstructions').val('');

    $('#ddlProofingType').val('Select').change();
    //For html table
    $("#tblAddConfigList tbody").html("");
    $("#tblAddReminderList tbody").html("");
    $('#ULTabul a[href="#ConfigTab"]').trigger('click');

  }
  addDynamicTagList() {
    const divElement = document.getElementById('DynamicTagList');
    if (divElement.style.display === 'none') {
      divElement.style.display = 'block';
    } else {
      divElement.style.display = 'none';
    }
  }

  TagListhide() {
    $("#DynamicTagList").hide();
    $("#DynamicTagListReminder").hide();

  }

  ConfirmationCloneProofingConfig() {
    ngswal({
      title: "Are you confirm to Clone Proofing Data?",
      text: "Clone Config Confirmation !",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Clone!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          ngswal({
            title: 'Please wait processing!.....',
            text: '',
            showCancelButton: false,
            showConfirmButton: false
          });
          $('#btnCloneConfig').trigger("click");
        } else {
          ngswal("Cancelled !", "You clicked cancel! :)", "warning");
        }
      });

  }

  CloneProofingConfig() {
    $('#LoadingImage').show();
    ApiMethod.getMethod(this.modelItem.CloneProofingConfig + '/' + localStorage.aEID + '/' + localStorage.aLoginID).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.hide();
        if (result.Status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: result.message,
            showConfirmButton: false,
            timer: 1500
          });
        }
        else {
          ngswal("Failed !", result.Message, "warning");
        }
        this.GetProofingList();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

}








